import { produce } from "immer";
import { Character } from "../types/characterTypes";

export function handleChange(
  section: keyof Character,
  field: string,
  value: string,
  setCharacter: React.Dispatch<React.SetStateAction<Character>>
) {
  setCharacter((prev) =>
    produce(prev, (draft) => {
      (draft[section] as any)[field] = value;
    })
  );
}

export function handleChangeArray(
  section: keyof Character,
  field: string,
  index: number,
  subfield: string,
  value: string,
  setCharacter: React.Dispatch<React.SetStateAction<Character>>
) {
  setCharacter((prev) =>
    produce(prev, (draft) => {
      (draft[section] as any)[field][index][subfield] = value;
    })
  );
}

export function handleChangeNestedArray(
  section: keyof Character,
  field: string,
  nestedField: string,
  relationshipIndex: number,
  itemIndex: number,
  subfield: string,
  value: string,
  setCharacter: React.Dispatch<React.SetStateAction<Character>>
) {
  setCharacter((prev) =>
    produce(prev, (draft) => {
      (draft[section] as any)[field][relationshipIndex][nestedField][itemIndex][
        subfield
      ] = value;
    })
  );
}

export function addListItem(
  section: keyof Character,
  field: string,
  subfield: string | undefined,
  template: any,
  setCharacter: React.Dispatch<React.SetStateAction<Character>>,
  relationshipIndex: number = 0
) {
  setCharacter((prev) =>
    produce(prev, (draft) => {
      // Ensure the section object exists
      if (!draft[section]) {
        (draft as any)[section] = {};
      }

      const sectionObj = draft[section] as any;

      // If we're working with a nested array (e.g. relationships[i].allies)
      if (subfield !== undefined) {
        // Ensure the parent array exists (e.g. relationships)
        if (!Array.isArray(sectionObj[field])) {
          sectionObj[field] = [];
        }

        // Ensure the object at the desired index exists
        if (!sectionObj[field][relationshipIndex]) {
          sectionObj[field][relationshipIndex] = {};
        }

        // Ensure the subfield array exists (e.g. allies, enemies, etc.)
        if (!Array.isArray(sectionObj[field][relationshipIndex][subfield])) {
          sectionObj[field][relationshipIndex][subfield] = [];
        }

        // Push the new template item
        sectionObj[field][relationshipIndex][subfield].push(template);
      } else {
        // Flat array case (e.g. goals.wants)
        if (!Array.isArray(sectionObj[field])) {
          sectionObj[field] = [];
        }

        sectionObj[field].push(template);
      }
    })
  );
}


